import { render } from "./App.vue?vue&type=template&id=02e316b7"
const script = {}

import "./App.vue?vue&type=style&index=0&id=02e316b7&lang=css"
script.render = render

export default script